export default __webpack_public_path__ + "static/media/tut-integration.bfa4706d.jpg";